import React, { useState, useCallback, useEffect } from "react";

import { User } from "lucide-react";
import cn from "classnames";
import { NavLink, Link, useNavigate } from "react-router-dom";
import styles from "./Navigation.module.css";
import { Language } from "../../../constants/sampleModels";
import am from "../../../assets/Flag_of_Armenia.svg.webp";
import en from "../../../assets/Flag_of_the_United_Kingdom.svg.webp";
import FileUpload from "../../../modules/FileUpload/FileUpload";
import { useAuth } from "../../../context/AuthContext";
import logo from "../../../assets/logo.svg";
import { getAdminOrganizations } from "../../../modules/signIn/api/index";
import { useLocale } from "../../../context/LocaleContext";
const Navigation = ({ handleSetLocale }) => {
  const { setErrorModalShow } = useLocale();
  const navigate = useNavigate();

  const { onLogout, userInfo } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [fileVersion, setFileVersion] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [organization, setOrganization] = useState([]);
  // const canUpload = userInfo?.some((item) => item.code === "forge.upload");

  const canUpload =
    userInfo?.some((item) => item.code === "forge.upload") ?? false;
  const handleUpload = (newFile) => {
    const fileToAdd = {
      id: newFile.id || `file-${Date.now()}`,
      description:
        newFile.description || newFile.name || newFile.fileName || "Unknown",
      urn: newFile.urn || newFile.objectKey || "",
      updated_at:
        newFile.updated_at || newFile.createdAt || new Date().toISOString(),
      size: newFile.size || newFile.fileSize || 0,
    };

    setFiles((prevFiles) => {
      const newFiles = [fileToAdd, ...prevFiles];
      return newFiles;
    });

    setSelectedFile(fileToAdd);

    setFileVersion((v) => v + 1);
    window.dispatchEvent(new Event("viewstruct:file-uploaded"));

    setTimeout(() => setUploadProgress(0), 1000);
  };
  const handleLogOut = useCallback(async () => {
    setSubmitting(true);
    try {
      await onLogout();
      setSubmitting(false);
      navigate("/");
    } catch (err) {
      setSubmitting(false);
    }
  }, [onLogout, navigate]);

  const getAdminOrgs = async () => {
    try {
      // setIsloading(true);
      const data = await getAdminOrganizations(setErrorModalShow);
      setOrganization(data);
      return data;
    } catch (error) {
      console.error("Get Admin Organizations error:", error);
      throw error.response?.data || error;
    }
    //  finally {
    //   setIsloading(false);
    // }
  };

  useEffect(() => {
    const token = window.localStorage.getItem("accessToken");
    if (token) {
      getAdminOrgs();
    }
  }, []);

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.logo}>
        <img src={logo} alt="viewStruct logo" srcset="" />
      </Link>
      <div className={styles.headerActions}>
        <Link to="/Dashboard" className={styles.dashboardLink}>
          <span>Dashboard</span>
        </Link>
        <Link to="/Issues" className={styles.issuesLink}>
          <span>Issues</span>
        </Link>
{/* 
        {canUpload && (
          <div className={styles.uploadSection}>
            <FileUpload
              accessToken={"dg"}
              onFileUploaded={(file) => {
                handleUpload(file);
              }}
              onUploadError={(err) => {
                console.error("❌ Upload error:", err);
                alert(err);
              }}
              onUploadProgress={(progress) => {
                setUploadProgress(progress);
              }}
            />
          </div>
        )} */}
        <button
          // className={cn(
          //   canUpload ? styles.userButton : styles.userButtonNoUpload,
          // )}
          // onClick={() => setShowUserMenu(!showUserMenu)}

          type="button"
          aria-label="User menu"
          className={cn(
            canUpload ? styles.userButton : styles.userButtonNoUpload,
          )}
          onClick={() => setShowUserMenu(!showUserMenu)}
        >
          <User size={20} />
        </button>
        {showUserMenu && (
          <div
            className={styles.userMenuOverlay}
            onClick={() => setShowUserMenu(false)}
          >
            <div
              className={styles.userMenu}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={styles.userMenuHeader}>
                <div className={styles.userAvatar}>
                  <User size={32} />
                </div>
                <div className={styles.userInfo}>
                  <h4 className={styles.userName}>
                    {organization?.name || "User"}
                  </h4>
                  <p className={styles.userEmail}>
                    {organization?.email || "user@example.com"}
                  </p>
                </div>
              </div>

              <div className={styles.userMenuDivider}></div>

              {/* <div className={styles.userMenuItems}>
                <Link to="/profile-settings" className={styles.userMenuItem}>
                  <User size={18} />
                  <span>Profile Settings</span>
                </Link>
                <Link to="/storage" className={styles.userMenuItem}>
                  <HardDrive size={18} />
                  <span>Storage</span>
                </Link>
                <Link to="/preferences" className={styles.userMenuItem}>
                  <SlidersHorizontal size={18} />
                  <span>Preferences</span>
                </Link>
              </div> */}

              <div className={styles.userMenuDivider}></div>

              <button
                className={styles.userMenuItemDanger}
                disabled={submitting}
                aria-expanded="false"
                aria-haspopup="true"
                onClick={handleLogOut}
              >
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navigation;
